@if (flags.length > 0) {
  <div class="badge">
    <eiq-badge [color]="'warn'" [text]="flags.length + ' flags'" (click)="showFlagsOverlay()" cdkOverlayOrigin></eiq-badge>
  </div>

  @if (showFlags$()) {
    <div class="overlay" #trigger></div>

    <ng-template
      #flagInfo
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="showFlags$()"
      (overlayOutsideClick)="closeFlagsOverlay()"
      (detach)="closeFlagsOverlay()"
    >
      <div class="flags" [@animations]>
        <div class="flags__header">
          <div class="flags__header-title">
            <fa-icon [icon]="faFlag" size="xl"></fa-icon>
            <span>{{ id }}'s account flags</span>
          </div>

          <eiq-button [text]="'Close flags info'" [icon]="faClose" [style]="'icon'" [color]="undefined" (clicked)="closeFlagsOverlay()"></eiq-button>
        </div>

        <div class="flags__info">
          @if (flags.length > 0) {
            <span>Flags list</span>
            <ul class="flags__info__list">
              @for (flag of flags; track flag) {
                <li>{{ flag }}</li>
              }
            </ul>
          } @else {
            <span>No flags</span>
          }
        </div>
      </div>
    </ng-template>
  }
}
